const tocButtonTemplate = ({accessBtnTableOfContents, tocIndex}) => `<button class="toc-button ui control-button tertiary-button" name="TableOfContents" type="button" title="${accessBtnTableOfContents}" tabindex="${tocIndex}" data-cy="toc-toggle-button">
   <span class="ui toc-button-glyph"></span>
</button>`;

export default tocButtonTemplate;
